var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      staticStyle: {
        "border-radius": "4px !important",
        border: "1px solid #dee5ec",
      },
      attrs: { shadow: "never", "body-style": "margin: 0px;" },
    },
    [
      _c("div", [
        _c(
          "div",
          {
            staticClass: "flex flex-row",
            staticStyle: { margin: "8px 24px 8px 8px" },
          },
          [
            _vm.devicePicture && _vm.devicePicture.src
              ? _c("img", {
                  staticStyle: { width: "80px", height: "80px" },
                  attrs: {
                    alt: _vm.devicePicture.alt,
                    src: _vm.devicePicture.src,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex-1", staticStyle: { margin: "8px" } },
              [
                _c("div", { staticClass: "flex flex-row" }, [
                  _c("div", { staticClass: "item-name flex-1" }, [
                    _vm._v(
                      "\n            " + _vm._s(_vm.title) + "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.quantity > 1
                    ? _c(
                        "div",
                        {
                          staticClass: "flex-1",
                          staticStyle: { "margin-top": "15px" },
                        },
                        [
                          _vm._v(
                            "\n            x" +
                              _vm._s(_vm.quantity) +
                              "\n          "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.subItem
                    ? _c("div", { staticClass: "item-price" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.formattedAmount) +
                            "\n          "
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "item-sku" },
                  [
                    _c("strong", [_vm._v("ASIN: ")]),
                    _vm._v(" " + _vm._s(_vm.sku) + "\n          "),
                    _vm.isInstallation
                      ? _c(
                          "el-tag",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { type: "warning", size: "mini" },
                          },
                          [_vm._v("\n            Installation\n          ")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.variantTitle !== "bundle"
                  ? _c(
                      "div",
                      {
                        staticClass: "item-status",
                        class:
                          "item-status-" +
                          _vm.status.replace(" ", "-").toLowerCase(),
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(_vm.status) + "\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _vm.quantity > 1 || _vm.variantTitle === "bundle"
          ? _c(
              "div",
              {
                staticStyle: { "margin-left": "96px", "margin-right": "24px" },
              },
              [
                _vm.expandBundle
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            _vm.expandBundle = false
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "show-button" }, [
                          _vm._v("\n          Show less\n        "),
                        ]),
                      ]
                    )
                  : _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            _vm.expandBundle = true
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "show-button" }, [
                          _vm._v("\n          Show more\n        "),
                        ]),
                      ]
                    ),
                _vm._v(" "),
                _vm.expandBundle
                  ? _c(
                      "div",
                      _vm._l(_vm.items, function (item, idx) {
                        return _c(
                          "order-details-item-view",
                          _vm._b(
                            {
                              key: idx,
                              staticStyle: { "margin-bottom": "8px" },
                              attrs: { "sub-item": true },
                            },
                            "order-details-item-view",
                            item,
                            false
                          )
                        )
                      }),
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }